import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";

import styles from "./styles.m.css";

const SubscriptionLink = ({ href, text = "Subscribe" }) => {
  if (!href) {
    return null;
  }

  return (
    <Link aria-label="Subscribe" className={styles["subscription-link"]} href={href}>
      <span className={styles["text"]}>{text}</span>
    </Link>
  );
};
SubscriptionLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string
};

export default SubscriptionLink;
